import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import Subjects from "../../models/subjects";
import { TicketService } from "../../services/ticket-service";

export default class TicketBar {

    ticketService: TicketService;

    id?: number | null;
    percent: number;
    isClone: boolean;
    subject: Subjects;

    constructor(subject: Subjects) {

        this.ticketService = new TicketService(subject);

        this.id = null;
        this.percent = 0;
        this.isClone = false;
        this.subject = subject;
        makeAutoObservable(this);
    }

    loadCurrent(): void {

        try {
            this.ticketService.loadCurrent(
                data => {
                    if (data?.id) {
                        runInAction(() => {
                            this.id = data['id'];
                            this.isClone = data['clone'];
                            this.percent = Math.ceil(data['currentTaskCount'] / data['taskCount'] * 100);
                        });
                    }
                }
            );
        } catch (error) {
            runInAction(() => { message.error(error) });
        }
    }

    update(id: number | null | undefined, currentTaskCount: number, taskCount: number): void {
        this.id = id;
        this.percent = Math.ceil(currentTaskCount / taskCount * 100);
    }
}